import { styled } from 'styled-components';

export const StyledNoneflexGrow = styled.div`
  flex: 0;
`;

export const StyledFullFlexGrow = styled.div`
  flex: 1;
`;
